import { Pipe, PipeTransform } from '@angular/core';

/**
  * PostCodePipe
  *
  * A pipe to transform postcode string
  */
@Pipe({ name: 'postcode' })
export class PostCodePipe implements PipeTransform {
  /**
  * Accepts a postcode and format, returns transformed value
  *
  * @param {string} postcode The postcode value to be transformed.
  * @param {string} format The format to use in transformation. Default is half
  * @return {string} Returns transformed postcode value.
  */
  transform(postcode: string, format = 'half'): string {
    if (format === 'half') {
      postcode = postcode.split(' ')[0]
    }
    return postcode;
  }
}
